class OracuraNewsletter extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.form = this.querySelector('form');
    this.button = this.querySelector('[type="submit"]');
    this.form?.addEventListener('submit', event => {
      if (this.readyToSubmit || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.sending) return;
      this.sending = true;
      this.form.classList.add('is-sending');
      this.button.setAttribute('aria-disabled', 'true');
      this.timer = setTimeout(() => {
        this.reset();
        if (!this.isConnected) return;
        this.readyToSubmit = true;
        // Re-enter the native form flow so Shopify validation and CAPTCHA still run.
        try { this.form.requestSubmit(this.button); }
        finally { this.readyToSubmit = false; }
      }, 820);
    }, { capture: true, signal: this.controller.signal });
    window.addEventListener('pageshow', () => this.reset(), { signal: this.controller.signal });
  }
  reset() {
    clearTimeout(this.timer);
    this.sending = false;
    this.form?.classList.remove('is-sending');
    this.button?.removeAttribute('aria-disabled');
  }
  disconnectedCallback() {
    this.reset();
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('oracura-newsletter')) customElements.define('oracura-newsletter', OracuraNewsletter);
